import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const CaretDownIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "caret-down",
  "CaretDownIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M8 11.3333L12 4.99998L4 4.99998L8 11.3333Z" fill={colorList[0]} fillOpacity="0.9"/></g></svg>
);

export default CaretDownIcon;
